import { useMemo } from 'react';
import Smiles from '../Smiles/Smiles';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { LOCALES } from 'src/constants/main';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  language: LOCALES;
  changeTextDirection: () => void;
  addSmile: (smile: string) => void;
}

const ButtonBlock = (props: IProps) => {
  const isEnLanguage = useMemo((): boolean => {
    return props.language === LOCALES.EN;
  }, [props.language]);

  return (
    <div className="d-flex flex-column ml-4">
      <button
        onClick={props.changeTextDirection}
        className={`button-block__button button-block__button_large flex-row${localeStore.language === LOCALES.EN ? '' : '-reverse'}`}
      >
        <Icon name={Icons.Text} size={20} color={isEnLanguage ? theme.colors.dark : theme.colors.gray2} className="flex-1" />
        <Icon
          name={Icons.Text}
          size={20}
          color={isEnLanguage ? theme.colors.gray2 : theme.colors.dark}
          className="button-block__button-icon-right flex-1"
        />
      </button>
      <div className="d-flex flex-row mt-2 justify-content-end">
        <Smiles addSmile={props.addSmile}>
          <button className="button-block__button button-block__button_small">
            <Icon name={Icons.Smile} size={20} color={theme.colors.dark} />
          </button>
        </Smiles>
      </div>
    </div>
  );
};

export default ButtonBlock;
